import React, { Fragment } from 'react';
import { StyleSheet } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { connect } from 'react-redux';
import lodashIsEmpty from 'lodash/isEmpty';

import FloatingButtonBottom from '../../Components/FloatingButtonBottom';
import FloatingContentProductCart from '../../Components/FloatingButtonBottom/ProductCart';
import { globalSpacing } from '../../Theme/styles';

import withProductController from './controller/withProductController';
import ExtraGroup from './ExtraGroup';
import Loader from './Loader';
import ProductFooter from './ProductFooter';
import ProductHeading from './ProductHeading';

class Product extends React.Component {
  _renderListItem = (item, index) => {
    const { controller } = this.props;
    let defaultSelected = controller.state.isUpdate
      ? controller.getSelectedExtra(item)
      : null;

    return (
      <ExtraGroup
        key={index}
        defaultSelected={defaultSelected}
        group={{ ...item, index }}
        onGroupSelection={controller.addOrRemoveExtras}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          controller.state.extrasCoords[index] = layout.y;
        }}
      />
    );
  };

  _renderListHeader = () => {
    const { controller, setParams } = this.props;
    return (
      <ProductHeading
        productData={this.props.productData}
        stock={controller.state.stocks.stock}
        thisProductOnCart={
          controller.state.isUpdate ? null : controller.state.thisProductOnCart
        }
        setParams={setParams}
      />
    );
  };

  _renderListFooter = () => {
    const { controller, productData, scrollHandlers } = this.props;
    return (
      <ProductFooter
        allowZero={productData.allowZero}
        fill={productData.fill}
        stocks={controller.state.stocks}
        addToCartPress={(isRemove) => {
          controller.onAddToCartPressed(
            scrollHandlers.ref.current,
            undefined,
            isRemove,
          );
        }}
      />
    );
  };

  _onScrollToIndexFailed = () => {}; // this function is fix for error happen when testing

  render() {
    const { controller, productData, productLoading, scrollHandlers } =
      this.props;

    if (productLoading) {
      return <Loader />;
    }

    return (
      <Fragment>
        <ScrollView
          bounces={false}
          style={styles.scrollWrapper}
          contentContainerStyle={styles.scrollContainer}
          showsVerticalScrollIndicator={false}
          {...scrollHandlers}
        >
          {/* Heading */}
          {this._renderListHeader()}

          {/* Extras */}
          {productData.extra_group.map(this._renderListItem)}

          {/* Footer */}
          {this._renderListFooter()}
        </ScrollView>

        {/* Add/Update to cart button */}
        <FloatingButtonBottom
          testID="addOrUpdateCartButton"
          visible={true}
          onPress={() =>
            controller.onAddToCartPressed(scrollHandlers.ref.current)
          }
          disabled={controller.state.disableAddOrUpdateButton}
          plain
        >
          <FloatingContentProductCart
            comparePrice={controller.getItemOriginalPrice()}
            fill={productData.fill}
            isAddOn={productData.isAddOn}
            isUpdate={controller.state.isUpdate}
            price={controller.getItemTotalPrice()}
            submitting={controller.state.submitting}
            isMealPlan={controller.isMealPlan}
          />
        </FloatingButtonBottom>
      </Fragment>
    );
  }
}

Product = withProductController(Product);

const styles = StyleSheet.create({
  scrollWrapper: {
    overflow: 'visible',
    top: 0,
  },
  scrollContainer: {
    marginTop: -21, // draggable area size
    paddingBottom: globalSpacing,
  },
});

const mapStateToProps = (state) => ({
  isAddingOrUpdatingCart: state.cart.isAddingOrUpdatingCart,
  productData: state.product.data,
  productLoading: state.product.loading,
  user: state.user.user,
  whenFilter: state.filter.home.when,
});

export default connect(mapStateToProps)(Product);
